import {
    StripeButton,
    StripeButtonHandleErrorCallback,
} from '@eventbrite/payments';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { submitCheckoutForm } from '../../../actions/checkout';
import { PaymentMethodType } from '../../../models/paymentMethods/enums';
import { CheckoutState } from '../../../state';

const mapDispatchToProps = (dispatch: Dispatch<CheckoutState>) => {
    return {
        submitFormCb: (
            token: { confirmationTokenID: string },
            buyer: { email: string; firstName: string; lastName: string },
            stripeRedirectedPaymentCallback: (
                paymentIntentClientSecret: string,
                handleErrorCallback: StripeButtonHandleErrorCallback,
            ) => Promise<void>,
        ) => {
            dispatch(
                submitCheckoutForm({
                    formData: {
                        paymentMethod:
                            PaymentMethodType.STRIPE_CONFIRMATION_TOKEN,
                        payment: token,
                        buyer: {
                            'N-email': buyer.email,
                            'N-first_name': buyer.firstName,
                            'N-last_name': buyer.lastName,
                        },
                        stripeRedirectedPaymentCallback,
                    },
                }),
            );
        },
    };
};

export const ConnectedStripeButton = connect(
    undefined,
    mapDispatchToProps,
)(StripeButton);
